import type { AdmissionPriceProps } from './calculate-booking-price.type';

export const calculateOnlinePrice = ({ offer, quantity }: AdmissionPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  if (offer.price.onlinePrice) {
    number += offer.price.onlinePrice * quantity;
  }
  return number;
};
